export const version = 'HEAD';
export const buildDate = '2026-01-14T01:09:53.585Z';
export const commitHash = '0eddff3';